import { forwardRef } from 'react';
import { Disableable } from '@optimus-web/common';
import { IconName } from '@optimus-web/icons';
import { VisuallyHidden } from '../helpers/VisuallyHidden';
import { Icon } from '../Icon';
import { BareIconButtonElement } from './style';
import { BareIconSize } from './types';

export interface BaseBareIconButtonProps extends Disableable {
    icon: IconName;
    accessibleText?: React.ReactChild;
    size?: BareIconSize;
    readOnly?: boolean;
}

export type BareIconButtonProps = BaseBareIconButtonProps & React.HTMLAttributes<HTMLButtonElement>;

const BareIconButton = forwardRef<HTMLButtonElement, BareIconButtonProps>(
    ({ icon, size = 'medium', disabled, accessibleText, readOnly, ...other }, ref) => (
        <BareIconButtonElement type="button" readOnly={readOnly} disabled={disabled} size={size} {...other} ref={ref}>
            <Icon value={icon} size={size} />
            {accessibleText && <VisuallyHidden>{accessibleText}</VisuallyHidden>}
        </BareIconButtonElement>
    )
);

export default BareIconButton;
